import { ProductTypeOptions } from '../contexts/types'

export type IsOneOfFn<T> = (arr: T[], item: T) => boolean

const productTypeIsOneOf: IsOneOfFn<ProductTypeOptions> = (
    productTypeArr,
    productType
) => {
    return productTypeArr.includes(productType)
}

export default productTypeIsOneOf
